export default __webpack_public_path__ + "12a181a8dfb52c201ff9da0f5e4bfdc6.woff";